export class LlpaCapCriteriaApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCriteria({ snapshotId }) {
    return this.#http.get('/api/llpa-cap-criteria', { params: { snapshotId } });
  }

  async createCriteria(body) {
    return this.#http.post('/api/llpa-cap-criteria', body);
  }

  async editCriteria({ criteriaId, ...body }) {
    return this.#http.put(`/api/llpa-cap-criteria/${criteriaId}`, body);
  }

  async deleteCriteria({ criteriaId }) {
    return this.#http.delete(`/api/llpa-cap-criteria/${criteriaId}`);
  }
}
